export const NAV = {
  logo: "nav-logo",
  linkShop: "nav-link-shop",
  linkResults: "nav-link-results",
  linkHow: "nav-link-how",
  ctaAssessment: "nav-cta-assessment",
  menuToggle: "nav-mobile-toggle",
};

export const HERO = {
  womensSide: "hero-womens-side",
  mensSide: "hero-mens-side",
  womensCta: "hero-womens-cta",
  mensCta: "hero-mens-cta",
  trustStrip: "hero-trust-strip",
};

export const MED_ZONE = {
  section: "medication-zone-section",
  card: (slug) => `zone-card-${slug}`,
};

export const RESULTS = {
  section: "results-section",
  stat: (slug) => `results-stat-${slug}`,
  quote: (slug) => `results-quote-${slug}`,
};

export const HOW = {
  section: "how-section",
  step: (n) => `how-step-${n}`,
};

export const CTA = {
  section: "final-cta-section",
  startAssessment: "final-cta-start-assessment",
};

export const FOOTER = {
  section: "footer-section",
};
